import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

export type StatusBadgeTone = 'neutral' | 'accent' | 'warning' | 'error';

/**
 * A small pill naming a state (trial, latest, hidden...). Projected content is
 * the label, optionally led by an icon. `accent` is for on / active states.
 */
@Component({
  selector: 'app-status-badge',
  template: '<ng-content />',
  styleUrl: './status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  host: {
    '[class.status-badge--accent]': "tone() === 'accent'",
    '[class.status-badge--warning]': "tone() === 'warning'",
    '[class.status-badge--error]': "tone() === 'error'",
    '[class.status-badge--md]': "size() === 'md'",
  },
})
export class StatusBadgeComponent {
  readonly tone = input<StatusBadgeTone>('neutral');
  readonly size = input<'sm' | 'md'>('sm');
}
